import { StyledLabel } from './Label.styles';
import { LabelProps } from './Label.typs';

const Label = ({ children }: LabelProps): JSX.Element => {
  return <StyledLabel>{children}</StyledLabel>;
};

export default Label;
